import { PayloadAction } from "@reduxjs/toolkit";

import { FormId } from "../../../../components/enums";
import {
  createGenericUISlice,
  GenericState,
  UIState,
} from "../../../../store/HOC/genericUI.slice";

import { ComponentId as AdditionalComponentId } from "./AdditionalData/enums";
import { ComponentId as ImagesDescriptionComponentId } from "./ImagesDescriptionData/enums";

export type FormDataInputs = {
  [FormId.DAMAGES_IMAGES_DESCRIPTION]: {
    [ImagesDescriptionComponentId.DESCRIPTION]: string;
  };
  [FormId.DAMAGES_ADDITIONAL]: {
    [AdditionalComponentId.ARE_PREVIOUS_DAMAGE_PRESENT]: string;
    [AdditionalComponentId.PREVIOUS_DAMAGE_DESCRIPTION]: string;
    [AdditionalComponentId.ARE_OTHER_DAMAGES_PRESENT]: string;
    [AdditionalComponentId.OTHER_DAMAGES_DESCRIPTION]: string;
    [AdditionalComponentId.PROPERTY_PLACE]: string;
  };
};

export type DamagesImagesDescriptionFormInputs =
  FormDataInputs[FormId.DAMAGES_IMAGES_DESCRIPTION];
export type DamagesAdditionalFormInputs =
  FormDataInputs[FormId.DAMAGES_ADDITIONAL];

type VehicleOwnerState = {
  data: FormDataInputs;
  ui: UIState;
};

const initialState: VehicleOwnerState = {
  data: {
    [FormId.DAMAGES_IMAGES_DESCRIPTION]: {
      [ImagesDescriptionComponentId.DESCRIPTION]: "",
    },
    [FormId.DAMAGES_ADDITIONAL]: {
      [AdditionalComponentId.ARE_PREVIOUS_DAMAGE_PRESENT]: "",
      [AdditionalComponentId.PREVIOUS_DAMAGE_DESCRIPTION]: "",
      [AdditionalComponentId.ARE_OTHER_DAMAGES_PRESENT]: "",
      [AdditionalComponentId.OTHER_DAMAGES_DESCRIPTION]: "",
      [AdditionalComponentId.PROPERTY_PLACE]: "",
    },
  },
  ui: {
    validated: false,
  },
};

const damagesSlice = createGenericUISlice({
  name: "@OC/vehicle/damages",
  initialState: initialState as GenericState<FormDataInputs>,
  reducers: {
    setData: (state, action: PayloadAction<FormDataInputs>) => {
      state.data[FormId.DAMAGES_IMAGES_DESCRIPTION] = {
        ...initialState.data[FormId.DAMAGES_IMAGES_DESCRIPTION],
        ...action.payload[FormId.DAMAGES_IMAGES_DESCRIPTION],
      };
      state.data[FormId.DAMAGES_ADDITIONAL] = {
        ...initialState.data[FormId.DAMAGES_ADDITIONAL],
        ...action.payload[FormId.DAMAGES_ADDITIONAL],
      };
      state.ui.validated = true;
    },
    setPreviousDamagePresent: (state, action: PayloadAction<string>) => {
      state.data[FormId.DAMAGES_ADDITIONAL][
        AdditionalComponentId.ARE_PREVIOUS_DAMAGE_PRESENT
      ] = action.payload;
    },
    setAreOtherDamagesPresent: (state, action: PayloadAction<string>) => {
      state.data[FormId.DAMAGES_ADDITIONAL][
        AdditionalComponentId.ARE_OTHER_DAMAGES_PRESENT
      ] = action.payload;
    },
  },
});

export const {
  setData: setDamagesFormData,
  setAreOtherDamagesPresent,
  setPreviousDamagePresent,
} = damagesSlice.actions;

export const { reducer } = damagesSlice;
